// this is going to be global contract in the lib
import { eBranches } from "../../dependencies";
import { Scoreboards } from "../../constants";
export const mapGameScore = (x) => {
    const emptyScore = {
        homeScore: "",
        awayScore: "",
        additionalScores: {},
        combinedSecondTierScores: []
    };
    x.score = Object.assign(Object.assign({}, emptyScore), x.score);
    x.scoreboard = Scoreboards[eBranches[x.sportId]] && Object.assign(Object.assign({}, Scoreboards.Empty()), Scoreboards[eBranches[x.sportId]](x));
    return x;
};
//# sourceMappingURL=mapGameScore.js.map